/**
 * Paths that are never locally cached
 */

const paths = [
  '/v1/users/profile',
  '/v1/organisation/userHasMembership',
  '/v1/ai/chat/threads',
  '/v1/location/list',
];
const regexPaths = [
  /\/v1\/command\/devel\/[a-f0-9]*\/HelloCommand/i,
  /\/v1\/heatmap\/[a-f0-9]*\/get-source-url/i,
  /\/v1\/ai\/chat\/threads\/[a-zA-Z0-9-]+/i,
];

export const neverCache = (path) => {
  if (paths.includes(path)) {
    return true;
  }

  for (let regex of regexPaths) {
    if (regex.test(path)) {
      return true;
    }
  }

  return false;
};
